<template>
  <div>
    <rest-form-item
      :label="$t('ChannelConfig_Messagebird_AccessKey')"
      prop="access_key"
    >
      <el-input
        v-model="model.params.access_key"
        :placeholder="$t('ChannelConfig_Messagebird_AccessKey_Placeholder')"
      />
    </rest-form-item>
    <rest-form-item
      :label="$t('ChannelConfig_Messagebird_SigningKey')"
      prop="signing_key"
    >
      <el-input
        v-model="model.params.signing_key"
        :placeholder="$t('ChannelConfig_Messagebird_SigningKey_Placeholder')"
      />
    </rest-form-item>
  </div>
</template>

<script>
import RestFormItem from '@/common/components/rest/RestFormItem'

export default {
  components: { RestFormItem },
  props: {
    model: {
      type: Object,
      required: true
    }
  },

  created() {
    if (!this.$route.query.id) {
      this.$set(this.model, 'type', 'sms')
      this.$set(this.model, 'channel', 'messagebird')
      this.$set(this.model, 'params', {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/channels/providers/MessageBird.vue